import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PriceBandReferenceService extends BaseReferenceService {
  constructor() {
    super('PriceBandReference');
  }
}
